import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { IAdaptLinkObject } from "@common/route/route.service";
import { MeetingsService } from "@org-common/lib/meetings/meetings.service";
import { EMPTY, Observable } from "rxjs";

@Component({
    selector: "adapt-link-team-meetings-page",
    templateUrl: "./link-team-meetings-page.component.html",
    standalone: false,
})
export class LinkTeamMeetingsPageComponent implements OnChanges {
    @Input() public team?: Team;

    public href$: Observable<IAdaptLinkObject> = EMPTY;
    public linkIcon = "fal fa-users";
    public linkText = "";

    public constructor(
        private meetingsService: MeetingsService,
    ) {
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.team && this.team) {
            this.linkText = this.team.name;
            this.href$ = this.meetingsService.getTeamMeetingsPageObjForTeam(this.team.teamId);
        }
    }
}
